<template>
  <!--Скелет поиска-->
  <div v-if="!contentLoaded" class="models-header models-header--skeleton mb-9 bg-skeleton"></div>
  <div v-else class="models-header mb-9">
    <div class="models-header_switch-wrap">
      <button
        @click="handleGridType('small')"
        class="models-header_switch"
        :class="{'models-header_switch--active': gridType === 'small'}"
        style="min-width: unset;"
      >
        <i class="icon-grid2"></i>
      </button>

      <button
        @click="handleGridType('big')"
        :class="{'models-header_switch--active': gridType === 'big'}"
        class="models-header_switch"
        style="min-width: unset;"
      >
        <i class="icon-grid1"></i>
      </button>

    </div>
    <div class="models-header_sorting-wrap d-none d-md-block">
      <bim-select
        v-model="sort"
        :options="sortList"
        width="151"
        style="height:100%"
        :searchable="false"
      />
    </div>
    <div class="models-header_search-wrap d-flex">
      <i class="icon-search1"></i>
      <input
        class="search-global search-global--library"
        id="searchModels"
        v-model="search"
        ref="inputSearch"
        @keydown.down.prevent="highlightedNext"
        @keydown.up.prevent="highlightedPrev"
        @keydown.enter.prevent="enterListItem()"
        @keydown.escape.prevent="close = true"
        @blur="onInputBlur"
        @focus="onInputFocus"
        @input="onInput"
        :placeholder="placeholder"
        :class="{'search--border': search !== ''}"
      />
      <div class="search_btn">
        <i @click.prevent="()=>setQueryParams({ nameQuery: 'search', arr: [search] })" class="icon-arrow-right"></i>
      </div>

      <bimManufacturerHints
        style="top: 60px"
        v-if="!showSearchHints"
        :inputFocus="inFocus"
        :search="search"
        :heedRequestData="false"
        @submit="submitHint"
      />

      <transition name="slideup-fade" v-if="showSearchHints && filteredDataClass">
        <transition-group tag="ul" name="list-complete" v-show="!close" class="search-list w-100 px-0" id="list_block" ref="searchModelList">
          <li
            v-for="(className, i) of filteredDataClass"
            :key="className.code"
            class="list_item cp"
            :class="{'active-list_item': i === highlightedIndex}"
          >
            <a @click="enterListItem(className.code)" v-if="className.code === 'search'">
              {{search}}
            </a>
            <a v-else @click="enterListItem(className.code)">
              {{className.name}}
              <span class="category-search">{{$t('Модели')}}</span>
            </a>
          </li>
        </transition-group>
      </transition>
    </div>
  </div>
</template>

<script>
import bimSelect from '@bimlib/components/bimSelect'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import bimManufacturerHints from '@bimlib/components/bimManufacturerHints'

export default {
  props: {
    placeholder: {
      type: String,
      default: 'Поиск',
    },
    // Показывать подсказки у поиска
    showSearchHints: {
      type: Boolean,
      default: true
    }
  },
  components: { bimSelect, bimManufacturerHints },
  data () {
    return {
      getClass: [],
      close: true,
      highlightedIndex: 0,
      inFocus: false,
      sortList: [
        { label: 'По популярности', value: 'popular' },
        { label: 'По новизне', value: 'new' },
      ],
    }
  },
  created () {
    this.handleGridType()
  },
  computed: {
    ...mapGetters([
      'searchFilter',
      'sortFilter',
      'gridType',
      'contentLoaded',
    ]),
    /**
     * Фильтрация массива классов во время ввода в строку поиска.
     * Строка поиска в списке не фильтруется.
     */
    filteredDataClass () {
      return this.getClass.filter(post => {
        if (post.code !== 'search') {
          return (
            post.name.toLowerCase().includes(this.search.toLowerCase()) ||
            post.meta_alias
              .toLowerCase()
              .includes(this.search.toLowerCase())
          )
        } else return post
      })
    },
    /**
     * Получаем значение поиска из vuex
     */
    search: {
      get () {
        return this.searchFilter
      },
      set (val) {
        this.searchFilteres(val)
      },
    },
    sort: {
      get () {
        return this.sortFilter
      },
      set (val) {
        if (val !== this.sortFilter) {
          this.setSort(val)
        }
      },
    },
  },

  methods: {
    ...mapMutations([
      'searchFilteres',
      'setGridType',
    ]),
    ...mapActions([
      'checkQueryParams',
      'setQueryParams',
      'setClasses',
      'setSort',
      'resetFilter',
      'toggleCheckbox',
      'setCategories'
    ]),
    /**
     * Запрос категорий для выпадающего списка по поисковой строке
     */
    async fetchModels () {
      if (this.showSearchHints && this.search.length >= 2) {
        this.close = false
        const data = await this.$store.dispatch('getClassBySearch', this.search)
        this.getClass = [{ code: 'search' }, ...data]
      } else {
        this.close = true
      }
    },

    onInput(e) {
      const { value } = e.target
      this.search = value
      this.inFocus = true
      this.fetchModels()
    },

    onInputFocus() {
      clearTimeout(this.focusTimer)
      this.inFocus = true
      this.fetchModels()
    },

    onInputBlur() {
      this.close = true
      this.focusTimer = setTimeout(() => {
        this.inFocus = false
      }, 400)
    },

    submitHint ({ group, item }) {
      this.inFocus = false
      const { type } = group

      this.search = item.label

      if (type === 'search') {
        this.setQueryParams({ nameQuery: 'search', arr: [this.search] })
      }

      if (type === 'manufacturers') {
        const manufacturers = this.$store.getters.manufacturersData
        const manufacturer = manufacturers.find(m => m.id === item.id)

        if (manufacturer) {
          manufacturer.checked = true
          this.setQueryParams({ nameQuery: 'search', arr: [''] })
          this.toggleCheckbox('manufacturers')
        }
      }

      if (type === 'categories') {
        this.setQueryParams({ nameQuery: 'search', arr: [''] })
        this.setCategories(item.id)
      }
    },

    /**
     * Скроллит список поиска при перемещении курсора если все элементы не влазят
     */
    scrollToHighligted () {
      this.$refs.searchModelList.children[this.highlightedIndex].elm.scrollIntoView({
        block: 'nearest',
      })
    },
    /**
     * Выставляет индекс выделенного элемента и сбрасывает его если дошел до конца и переместился в начало списка
     */
    highlight (index) {
      this.highlightedIndex = index

      if (this.highlightedIndex < 0) {
        this.highlightedIndex = this.filteredDataClass.length - 1
      }
      if (this.highlightedIndex > this.filteredDataClass.length - 1) {
        this.highlightedIndex = 0
      }
      this.scrollToHighligted()
    },

    /**
     * Листает курсор списка вверх
     */
    highlightedPrev () {
      if (!this.showSearchHints) {
        return
      }

      this.highlight(this.highlightedIndex - 1)
    },

    /**
     * Листает курсор списка вниз
     */
    highlightedNext () {
      if (!this.showSearchHints) {
        return
      }

      this.highlight(this.highlightedIndex + 1)
    },
    /**
     * Выбор текущего элемента в выпадающем списке и отправка данных в vuex.
     * Если значение не передано, поиск идёт по индексу подсвеченного элемента (в случае нажатия на Enter)
     * При клике на элемент сразу передаётся значение этого элемента, забивается адресная строка и отправляется в vuex для обработки и рендера моделей.
     * При выполнении поиска список закрывается.
     * При выборе класса, вся строка чистится и вводится только класс.
     * При выборе введеного значения это значение добавляется уже к существующей адресной строке
     */
    enterListItem (val) {
      if (!this.showSearchHints) {
        return
      }

      let code = val
      if (!val) {
        const selectedObj = this.filteredDataClass.find((el, idx) => idx === this.highlightedIndex)
        code = selectedObj.code
      }

      if (code !== 'search') {
        this.resetFilter('all')
        this.setClasses(code)
      }
      this.setQueryParams({ nameQuery: 'search', arr: [this.search] })
      this.close = true
    },
    handleGridType (val) {
      if (val) { localStorage.setItem('lib-grid-type', val) }
      this.setGridType(localStorage.getItem('lib-grid-type') || 'small')
    },
  },
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";
// @media (min-width: $breakpoint-xs) and (max-width: width-max($breakpoint-md)) {}
.models-header::v-deep .select__cnt {
  height: 100%;
}
.models-header::v-deep .input__form {
   border: none;
   border-radius: 0;
   height: 100%;
}
.models-header::v-deep .arrow__icon__wrp {
  height: 100%;
  width: 30px;
  opacity: .5;
}
.models-header::v-deep .select__label {
  font-size: 12px;
  font-weight: 700;
  line-height: 1.67;
  letter-spacing: normal;
  color: #4d4d4d;
  width: 100%;
}

.models-header {
  height           : 48px;
  background-color : $white-color;

  /*overflow         : hidden;*/
  display          : flex;
  border-radius    : 5px;
  box-shadow       : 0 3px 8px 0 rgba(0, 0, 0, 0.05);
  border           : solid 1px $white-color-500;

  &--skeleton {
    width         : 100%;
    border-radius : 3px;
  }

  &_switch-wrap {
    width           : 105px;
    height          : 100%;
    display         : flex;
    justify-content : center;
    align-items     : center;
    border-right    : solid 1px $white-color-500;
    @media (min-width : $breakpoint-xs) and (max-width : width-max($breakpoint-md)) {
      width : 70px;
    }
  }

  &_switch {
    min-width  : auto;
    min-height : auto;
    width      : 18.5px !important;
    height     : auto;
    padding    : 0;

    i::before {
      font-size               : 18px;
      -webkit-text-fill-color : #DBDBDB;
      color                   : #DBDBDB;
      transition              : all 0.2s;
    }

    &:last-child {
      margin-left : 16px;
      @media (min-width : $breakpoint-xs) and (max-width : width-max($breakpoint-md)) {
        margin-left : 12px;
      }
    }

    &:hover {
      background-color : unset;

      i::before {
        -webkit-text-fill-color : $active;
      }
    }

  }

  &_switch--active {
    i::before {
      -webkit-text-fill-color : $active;
    }
  }

  &_sorting-wrap {
    border-right : solid 1px $white-color-500;
  }

  &_search-wrap {
    position  : relative;
    height    : 100%;
    flex-grow : 1;

    i.icon-search1 {
      position  : absolute;
      left      : 14px;
      top       : 50%;
      transform : translateY(-50%);
      opacity   : .5;
    }
  }
}

.under_search {
  @include font-main(12px, normal, 1.75, 0.2px, $text-super-light);
}

.search-tab_link {
  cursor : pointer;

  @include font-main(18px, bold, 1.33, normal, $text-search);

  &:hover {
    color : $text-second-dark;
  }
}

.search-tab_link--active {
  color : $active !important;
}

.search-wrapper {
  position    : relative;

  padding-top : 5rem;
  // overflow: hidden;
}

.search-models {
  border-radius      : 0 5px 5px 0;
  box-shadow         : none;
  border-right       : solid 0.5px #e6e6e6;
  border-top         : solid 0.5px #e6e6e6;
  border-bottom      : solid 0.5px #e6e6e6;
  -webkit-appearance : none;
}

.icon_search {
  padding-right : 2.1333rem;

  color         : $text-soft-dark;
}

.label-list {
  display     : inline-flex;
  padding     : 0rem 2.1333rem;

  font-weight : bold;
}

.list_item {
  @media (min-width : $breakpoint-xs) and (max-width : width-max($breakpoint-md)) {
    font-size : 14px;
  }
}

.active-list_item {
  // background-color: $bg-search;
  // background-color: $active;
}

.slide-fade-enter-active {
  transition : all 0.3s ease;
}

.slide-fade-leave-active {
  transition : all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  // transform: translateX(0.625rem);
  opacity : 0;
}

.slideup-fade-enter-active {
  transition : all 0.3s ease;
}

.slideup-fade-leave-active {
  transition : all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slideup-fade-enter,
.slideup-fade-leave-to
  /* .slide-fade-leave-active до версии 2.1.8 */
{
  // transform: translateY(-0.625rem);
  opacity : 0;
}

.list-complete-enter, .list-complete-leave-to {
  opacity   : 0;
  transform : translateY(30px);
}

.list-complete-leave-active {
  /*position: absolute;*/
}

// Модели
// .models {
//   max-height: 20.7rem;
//   padding-top: 2px;
//   overflow: hidden;

//   transition: all 0.3s;
// }
.show {
  max-height : 100% !important;
}

.activeInf {
  color                   : $active;

  fill                    : $active;
  -webkit-text-fill-color : $active;
}

.op1 {
  opacity : 1 !important;

  &:hover {
    opacity : .5 !important;
  }
}
</style>
